// extracted by mini-css-extract-plugin
export default {"container":"TopLevelErrorBoundary-module__container--Icfoh","h1":"TopLevelErrorBoundary-module__h1--WmACH","button":"TopLevelErrorBoundary-module__button--MOfUm"};